import React, { useEffect } from "react";
import "../../styles/LoginPage.css";
import "../../styles/DPA.css";
import "../../styles/CompanyStyles/CompanyCultureSection.css";
import CompanyRegistrationSection from "../../components/Company/CompanyRegistration/CompanyRegistrationSection";

function CompanyRegistrationPage() {
  return (
    <>
      <CompanyRegistrationSection />
    </>
  );
}

export default CompanyRegistrationPage;
